import React from 'react'
import './styles.scss'

interface Proptype {
  title: string
  Icon?: JSX.Element
  onClick: () => void | void
  style?: object
  className?: string
  disabled?: boolean
  id?: string
}

interface INoBackgroundProptype {
  title: string
  onClick: () => void | void
  style?: object
  className?: string
  disabled?: boolean
}

export default function Button({ disabled, title, Icon, onClick, style, className = '', id = '' }: Proptype) {
  return (
    <button
      onClick={onClick}
      className={`mellro-button ${className}`}
      style={style}
      disabled={disabled}
      id={id}
    >
      {Boolean(Icon) && <div className='icon'>{Icon}</div>}
      <div className='text'>{title}</div>
    </button>
  )
}

export function NoBackgroundButton({
  disabled,
  title,
  onClick,
  style,
  className = '',
}: INoBackgroundProptype) {
  return (
    <button
      onClick={onClick}
      className={`mellro-button no-background ${className}`}
      style={style}
      disabled={disabled}
    >
      <div className='text no-background'>{title}</div>
    </button>
  )
}
